// Envio do Novo Pedido do Delivery (30/09/2026): o erro que o servidor mandou
// e a chave que impede pedido em dobro numa nova tentativa.

/** Texto do erro do servidor (`detail`, ou a lista do 422) ou o padrão. */
export function mensagemDoErro(error, padrao) {
  const d = error?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x?.msg || String(x)).join(" · ");
  const m = error?.response?.data?.message;
  return typeof m === "string" && m.trim() ? m : padrao;
}

/**
 * `chave_envio` do POST /api/pedidos: gerada uma vez por pedido em montagem e
 * repetida nas novas tentativas. Com a mesma chave (até 30 min) o servidor
 * devolve o pedido já criado em vez de criar outro.
 */
export function novaChaveEnvio() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch { /* navegador sem randomUUID (http): cai no de baixo */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
